import React from "react";

const GiaLogo = ({ relative, css }) => {
    return (
        <div className={`${css ? css : `bg0 fs8 h36 m4 mA mr10 dF jcC aiC taR w36 br4 oH ${relative ? "pR" : "pA r10 t0 bm0"}`}`}>
            <img src="https://assets-dev.geniemode.com/geniemode-dev-assets/order_documents/db19d37f-ca60-4cf4-8385-70373fe88593/2022_7_sphereorderdisorder.gif" className="pA t0 r0 hp100 ofC wp100" />
            <div className="cF fs8 fwB ls1 o9 wp100 hp100 dF jcC aiC" style={{ backdropFilter: "brightness(3)" }}>
                <div>GIA</div>
            </div>
        </div>
    );
};

export default GiaLogo;
